module.exports = require("./fr-RE.d.ts");